import { configureStore } from '@reduxjs/toolkit';
import generalReducer from 'Features/generalSlice';
import languageReducer from 'Features/languageSlice';
import testimonialReducer from 'Features/testimonialSlice';
export const store = configureStore({
    reducer: {
      'general': generalReducer,
      'language': languageReducer,
      'testimonial': testimonialReducer,
    }
});
